import React, { useState, useEffect, useRef, useCallback } from 'react'
import ReactPlayer from 'react-player'
import PlayIcon from '@material-ui/icons/PlayCircleFilled'
import PauseIcon from '@material-ui/icons/PauseCircleFilled'
import CloseIcon from '@material-ui/icons/Close'
import MarkIcon from '@material-ui/icons/LocationOn'
import { Toast } from 'react-bootstrap'
import { LARGE_DESKTOP, MEDIUM, RESUME_VIDEO } from '../constants'
import { FloatingSubmit } from '../UIUtilsFiles/FloatingSubmit'

function VideoCoreComponent(props) {
  const {
    videoData,
    onVideoControlChange,
    onPopupValueChange,
    videoResume,
    markerStatusList,
    handleMarkStatus,
    completed,
    isRecording,
    onRecordAlert,
    onNormalPopupClick,
    handleVideoClose,
    isRecordPlaying,
    isSeqPlay,
    feedPlay,
    isReplayHappening,
    followTheFlow,
    priorityActive,
    isContainedView,
    isActive
  } = props
  const { ControlID, Width, Height, X, Y, Url, Mark, VideoSkip, Priority } =
    videoData
  const video = {
    ControlID: ControlID,
    Url: Url,
    Width: Width,
    Height: Height,
    X: X,
    Y: Y,
    MarkData: Mark,
    VideoSkip: VideoSkip
  }
  const [playing, setPlaying] = useState(false)
  const [seekValue, setSeekValue] = useState(0)
  const [manualSeekValue, setManualSeekValue] = useState(0)
  const [dummySeekValue, setDummySeekValue] = useState(0)
  const [manualSelectedIndex, setManualSelectedIndex] = useState(-1)
  const [videoDuration, setVideoDuration] = useState(0)
  const [allMarkersDuration, setAllMarkersDuration] = useState([])
  const [selectedMarkIndex, setSelectedMarkIndex] = useState(-1)
  const [externalPopupVisible, setExternalPopupVisible] = useState(false)
  const [textPopupVisible, setTextPopupVisible] = useState(false)
  const [resumeVideoStatus, setResumeVideoStatus] = useState(false)
  const [internalDisplay, setInternalDisplay] = useState(false)
  const [isVideoStart, setIsVideoStart] = useState(false)
  const videoRef = useRef()
  const videoDivRef = useRef()
  const currentVideoPlayer = useRef()

  const [selectedMarkValueNormal, setSelectedMarkValueNormal] = useState('')

  //Convert all the markers to seconds
  useEffect(() => {
    if (video.MarkData) {
      const markerDuration = video.MarkData.map((MarkerData) => {
        const { Seconds } = MarkerData
        const splitedArray = Seconds.split(':')
        const seconds =
          splitedArray.length === 3
            ? parseInt(splitedArray[2])
            : parseInt(splitedArray[1])
        const minutes =
          splitedArray.length === 3
            ? parseInt(splitedArray[1])
            : parseInt(splitedArray[0])
        const hours = splitedArray.length === 3 ? parseInt(splitedArray[0]) : 0
        return hours * 3600 + minutes * 60 + seconds
      })
      setAllMarkersDuration(markerDuration)
    }
  }, [])

  useEffect(() => {
    currentVideoPlayer.current = video.ControlID
  }, [playing])

  //Handle video fullscreen
  useEffect(() => {
    if (isVideoStart) {
      setSelectedMarkIndex(-1)
      onVideoControlChange(true, video.ControlID)
    } else {
      onVideoControlChange(false, video.ControlID)
    }
  }, [isVideoStart])

  //Handle resume video
  useEffect(() => {
    if (videoResume) {
      setPlaying(true)
      setResumeVideoStatus(true)
      setTimeout(() => {
        setResumeVideoStatus(false)
      }, 2000)
    }
  }, [videoResume])

  //Trigger popup when marker duration is reached
  useEffect(() => {
    if (manualSeekValue === 0) {
      //check the marker duration when normal seek
      if (seekValue > 0 && manualSelectedIndex === -1) {
        if (allMarkersDuration.includes(parseInt(seekValue))) {
          let markIndex = allMarkersDuration.indexOf(parseInt(seekValue))
          let manualSelectedIndexCopy = allMarkersDuration[markIndex]
          setManualSelectedIndex(manualSelectedIndexCopy)
          setPlaying(false)
          let selectedMark = video.MarkData[markIndex]
          if (selectedMark.MarkerType === 'existing') {
            setInternalDisplay(false)
            onPopupValueChange([selectedMark.MarkerValue], video.ControlID)
          } else {
            setSelectedMarkIndex(markIndex)
            if (selectedMark.MarkerType === 'popup') {
              setSelectedMarkValueNormal(selectedMark.MarkerValue)
              setExternalPopupVisible(false)
              setTextPopupVisible(true)
              setInternalDisplay(true)
            } else {
              setSelectedMarkValueNormal(selectedMark.MarkerValue)
              setExternalPopupVisible(true)
              setTextPopupVisible(false)
              setInternalDisplay(true)
            }
          }
        }
      } else {
        if (parseInt(seekValue) > manualSelectedIndex) {
          setManualSelectedIndex(-1)
        }
      }
    } else {
      //check the marker duration when manual seek
      setSeekValue(manualSeekValue)
      videoRef.current.seekTo(manualSeekValue)
      setDummySeekValue(manualSeekValue)
      if (manualSeekValue >= dummySeekValue) {
        if (allMarkersDuration.includes(parseInt(manualSeekValue))) {
          let markIndex = allMarkersDuration.indexOf(parseInt(manualSeekValue))
          let manualSelectedIndexCopy = allMarkersDuration[markIndex]
          setManualSelectedIndex(manualSelectedIndexCopy)
          setPlaying(false)

          //Check previous marker is answered while click marker
          let filteredMarkerData = []
          allMarkersDuration.map((allMarkerData, index) => {
            if (allMarkerData < manualSeekValue) {
              let checkMarkPresent =
                markerStatusList &&
                markerStatusList.hasOwnProperty(
                  video.MarkData[index].MarkerValue
                )
              if (
                !checkMarkPresent
                //&&video.MarkData[index].MarkerType === "existing"
              ) {
                let markerDataCopy = {
                  SlideID: video.MarkData[index].MarkerValue,
                  Seconds: allMarkerData,
                  MarkerType: video.MarkData[index].MarkerType
                }
                filteredMarkerData.push(markerDataCopy)
              }
            }
          })
          let sortedArray = filteredMarkerData.sort(
            (a, b) => a.Seconds - b.Seconds
          )
          if (sortedArray.length > 0) {
            let filteredMarkerDataCopy = [sortedArray[0].SlideID]
            setManualSelectedIndex(sortedArray[0].Seconds)
            setSeekValue(sortedArray[0].Seconds)
            videoRef.current.seekTo(sortedArray[0].Seconds)
            if (sortedArray[0].MarkerType === 'existing') {
              setInternalDisplay(false)
              onPopupValueChange(filteredMarkerDataCopy, video.ControlID)
            } else if (sortedArray[0].MarkerType === 'popup') {
              let markIndexCopy = video.MarkData.findIndex(
                (entry) => entry.MarkerValue === sortedArray[0].SlideID
              )
              setSelectedMarkIndex(markIndexCopy)
              setSelectedMarkValueNormal(sortedArray[0].SlideID)
              setExternalPopupVisible(false)
              setTextPopupVisible(true)
              setInternalDisplay(true)
            } else {
              setExternalPopupVisible(true)
              setTextPopupVisible(false)
              setInternalDisplay(true)
            }
            onPopupValueChange(filteredMarkerDataCopy, video.ControlID)
          } else {
            let selectedMark = video.MarkData[markIndex]
            if (selectedMark.MarkerType === 'existing') {
              setSelectedMarkValueNormal('')
              setInternalDisplay(false)
              onPopupValueChange([selectedMark.MarkerValue], video.ControlID)
            } else {
              setSelectedMarkIndex(markIndex)
              if (selectedMark.MarkerType === 'popup') {
                setSelectedMarkValueNormal(selectedMark.MarkerValue)
                setExternalPopupVisible(false)
                setTextPopupVisible(true)
                setInternalDisplay(true)
              } else {
                setSelectedMarkValueNormal(selectedMark.MarkerValue)
                setExternalPopupVisible(true)
                setTextPopupVisible(false)
                setInternalDisplay(true)
              }
            }
          }
        } else {
          //Check previous marker is answered while doing forward seek
          let filteredMarkerData = []
          allMarkersDuration.map((allMarkerData, index) => {
            if (allMarkerData < manualSeekValue) {
              let checkMarkPresent =
                markerStatusList &&
                markerStatusList.hasOwnProperty(
                  video.MarkData[index].MarkerValue
                )
              if (
                !checkMarkPresent
                //&&video.MarkData[index].MarkerType === "existing"
              ) {
                let markerDataCopy = {
                  SlideID: video.MarkData[index].MarkerValue,
                  Seconds: allMarkerData,
                  MarkerType: video.MarkData[index].MarkerType
                }
                filteredMarkerData.push(markerDataCopy)
              }
            }
          })
          let sortedArray = filteredMarkerData.sort(
            (a, b) => a.Seconds - b.Seconds
          )
          if (sortedArray.length > 0) {
            setSelectedMarkValueNormal('')
            let filteredMarkerDataCopy = [sortedArray[0].SlideID]
            setManualSelectedIndex(sortedArray[0].Seconds)
            setPlaying(false)
            setSeekValue(sortedArray[0].Seconds)
            videoRef.current.seekTo(sortedArray[0].Seconds)
            if (sortedArray[0].MarkerType === 'existing') {
              setInternalDisplay(false)
              onPopupValueChange(filteredMarkerDataCopy, video.ControlID)
            } else if (sortedArray[0].MarkerType === 'popup') {
              setSelectedMarkValueNormal(sortedArray[0].SlideID)
              setExternalPopupVisible(false)
              setTextPopupVisible(true)
              setInternalDisplay(true)
            } else {
              setSelectedMarkValueNormal(sortedArray[0].SlideID)
              setExternalPopupVisible(true)
              setTextPopupVisible(false)
              setInternalDisplay(true)
            }
          }
        }
      }
      setManualSeekValue(0)
    }
  }, [seekValue, manualSeekValue])

  const toggle = () => {
    if (isRecording || isRecordPlaying) {
      onRecordAlert(true)
    } else {
      //Send marker status to parent
      if (followTheFlow) {
        if (!isSeqPlay && !feedPlay) {
          handleMarkStatus(markerStatusList)
          setIsVideoStart(true)
          setPlaying(!playing)
          handleVideoClose(false)
        }
      } else {
        handleMarkStatus(markerStatusList)
        setIsVideoStart(true)
        setPlaying(!playing)
        handleVideoClose(false)
      }
    }
  }

  //Seconds convertion to display markers in seekbar
  function funcMarkerDuration(markerSeconds) {
    const splitedArray = markerSeconds.split(':')
    const seconds =
      splitedArray.length === 3
        ? parseInt(splitedArray[2])
        : parseInt(splitedArray[1])
    const minutes =
      splitedArray.length === 3
        ? parseInt(splitedArray[1])
        : parseInt(splitedArray[0])
    const hours = splitedArray.length === 3 ? parseInt(splitedArray[0]) : 0
    return hours * 3600 + minutes * 60 + seconds
  }

  const handleExternalPopup = () => {
    setExternalPopupVisible(false)
    setTextPopupVisible(false)
    setInternalDisplay(false)
    setSelectedMarkIndex(-1)
    setPlaying(true)
    setResumeVideoStatus(true)
    setTimeout(() => {
      setResumeVideoStatus(false)
    }, 2000)
    setSelectedMarkValueNormal('')
  }

  const handlePopupText = () => {
    setExternalPopupVisible(false)
    setTextPopupVisible(false)
    setInternalDisplay(false)
    setSelectedMarkIndex(-1)
    setPlaying(true)
    setResumeVideoStatus(true)
    setTimeout(() => {
      setResumeVideoStatus(false)
    }, 2000)
    setSelectedMarkValueNormal('')
  }

  function renderResumeToast() {
    return (
      <Toast
        show={resumeVideoStatus}
        style={{
          position: 'absolute',
          zIndex: 6,
          top: '2%',
          left: '40%',
          //marginRight: "10px",
          width: '100%',
          backgroundColor: '#70ff96',
          alignSelf: 'center'
        }}
      >
        <Toast.Body
          style={{ color: 'black', textAlign: 'center', fontSize: MEDIUM }}
        >
          {RESUME_VIDEO}
        </Toast.Body>
      </Toast>
    )
  }

  function renderCloseIcon() {
    return (
      <div
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          backgroundColor: '#0093d180',
          position: 'absolute',
          top: '2%',
          right: '5%',
          zIndex: 1,
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        onClick={() => {
          setPlaying(false)
          setInternalDisplay(false)
          videoRef.current.seekTo(0)
          setSeekValue(0)
          setDummySeekValue(0)
          setSelectedMarkIndex(-1)
          onVideoControlChange(false, video.ControlID)
          currentVideoPlayer.current = undefined
          setIsVideoStart(false)
          setSelectedMarkValueNormal('')
          //  handleVideoClose(true)
        }}
      >
        <CloseIcon
          style={{
            width: '30px',
            height: '30px',
            cursor: 'pointer',
            color: 'white',
            zIndex: 4
          }}
        />
      </div>
    )
  }

  useEffect(() => {
    if (selectedMarkIndex && video.MarkData[selectedMarkIndex]) {
      console.log('video.MarkData', video.MarkData)
      console.log(
        'selectedMarkIndex',
        video.MarkData[selectedMarkIndex].MarkerName
      )
    }
  }, [selectedMarkIndex])

  function renderExternalPopup() {
    let urlText = ''
    if (video.MarkData[selectedMarkIndex]) {
      urlText = video.MarkData[selectedMarkIndex].MarkerValue
      if (urlText.includes('https://www.youtube.com/')) {
        let splitTextArr = urlText.split('https://www.youtube.com')
        urlText = 'https://www.youtube.com/embed' + splitTextArr[1]
      } else if (urlText.includes('https://youtu.be/')) {
        let splitTextArr = urlText.split('https://youtu.be')
        urlText = 'https://www.youtube.com/embed' + splitTextArr[1]
      } else {
        urlText = video.MarkData[selectedMarkIndex].MarkerValue
      }
    }

    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          position: 'absolute',
          top: 0,
          zIndex: 2,
          alignSelf: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#00000080'
        }}
      >
        <div
          style={{
            width: '80%',
            height: '80%',
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: '1%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div
            style={{
              width: '100%',
              height: '10%',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <p
              style={{
                width: '100%',
                margin: 'auto',
                color: 'black',
                fontSize: LARGE_DESKTOP
              }}
            >
              {video.MarkData[selectedMarkIndex] &&
                video.MarkData[selectedMarkIndex].MarkerName}
            </p>
            <CloseIcon
              style={{
                width: '30px',
                height: '30px',
                cursor: 'pointer',
                color: 'black',
                zIndex: 4
              }}
              onClick={() => {
                if (selectedMarkValueNormal !== '') {
                  onNormalPopupClick(selectedMarkValueNormal, video.ControlID)
                }
                handleExternalPopup()
              }}
            />
          </div>
          <span
            style={{
              width: '100%',
              height: '2px',
              backgroundColor: '#BDBDBD',
              marginBottom: '1%'
            }}
          />
          <iframe
            src={urlText}
            title='description'
            style={{ width: '100%', height: '90%' }}
          />
        </div>
      </div>
    )
  }

  function renderPopupText() {
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          position: 'absolute',
          top: 0,
          zIndex: 2,
          alignSelf: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#00000080'
        }}
      >
        <div
          style={{
            width: '30%',
            maxHeight: '40%',
            minHeight: '20%',
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: '1%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div
            style={{
              width: '100%',
              height: '10%',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <p
              style={{
                width: '100%',
                margin: 'auto',
                color: 'black',
                fontSize: LARGE_DESKTOP
              }}
            >
              {video.MarkData[selectedMarkIndex] &&
                video.MarkData[selectedMarkIndex].MarkerName}
            </p>
            <CloseIcon
              style={{
                width: '30px',
                height: '30px',
                cursor: 'pointer',
                color: 'black',
                zIndex: 4
              }}
              onClick={() => {
                if (selectedMarkValueNormal !== '') {
                  onNormalPopupClick(selectedMarkValueNormal, video.ControlID)
                }
                handlePopupText()
              }}
            />
          </div>
          <span
            style={{
              width: '100%',
              height: '2px',
              backgroundColor: '#BDBDBD'
            }}
          />
          <div style={{ width: '100%', height: '88%', padding: '2%' }}>
            <p
              style={{
                width: '100%',
                height: '100%',
                color: 'black',
                whiteSpace: 'pre-wrap',
                overflow: 'auto',
                overflowX: 'hidden',
                wordWrap: 'break-word',
                margin: 'auto'
              }}
            >
              {video.MarkData[selectedMarkIndex] &&
                video.MarkData[selectedMarkIndex].MarkerValue}
            </p>
          </div>
        </div>
      </div>
    )
  }

  function renderFloatingDone() {
    if (isContainedView || video.MarkData.length === 0) {
      if (
        !isVideoStart &&
        !internalDisplay &&
        priorityActive === Priority &&
        !isSeqPlay &&
        !feedPlay
      ) {
        return (
          <FloatingSubmit
            submitClicked={() => {
              handleVideoClose(true)
            }}
          />
        )
      } else {
        return null
      }
    } else {
      if (markerStatusList) {
        let allMarkAttend = false
        if (
          markerStatusList &&
          video.MarkData &&
          Object.keys(markerStatusList).length === video.MarkData.length
        ) {
          allMarkAttend = true
        }
        if (allMarkAttend) {
          if (
            !isVideoStart &&
            !internalDisplay &&
            priorityActive === Priority &&
            !isSeqPlay &&
            !feedPlay
          ) {
            return (
              <FloatingSubmit
                submitClicked={() => {
                  handleVideoClose(true)
                }}
              />
            )
          } else {
            return null
          }
        } else {
          return null
        }
      } else {
        return null
      }
    }
  }

  return (
    <div
      style={{
        height: isVideoStart
          ? '100%'
          : internalDisplay
          ? '100%'
          : video.Height + '%',
        width: isVideoStart
          ? '100%'
          : internalDisplay
          ? '100%'
          : video.Width + '%',
        left: isVideoStart ? 0 : internalDisplay ? 0 : video.X,
        top: isVideoStart ? 0 : internalDisplay ? 0 : video.Y,
        position: 'absolute',
        zIndex: isVideoStart
          ? currentVideoPlayer.current === video.ControlID
            ? 10
            : 2
          : 5
      }}
    >
      {followTheFlow && completed === 0 && isActive && renderFloatingDone()}
      <div
        ref={videoDivRef}
        style={{
          width: isVideoStart ? '100vw' : '100%',
          height: isVideoStart ? '100vh' : '100%',
          position: isVideoStart ? 'absolute' : 'relative',
          top: isVideoStart ? 0 : undefined,
          left: isVideoStart ? 0 : undefined,
          backgroundColor: 'black',
          pointerEvents:
            isSeqPlay || feedPlay || isReplayHappening ? 'none' : 'auto'
        }}
      >
        <div style={{ width: '100%', height: '100%' }}>
          <ReactPlayer
            ref={videoRef}
            url={video.Url}
            width='100%'
            height='100%'
            playing={playing}
            onPlay={() => setPlaying(true)}
            onPause={() => setPlaying(false)}
            onEnded={() => {
              setPlaying(false)
              onVideoControlChange(false, video.ControlID)
              currentVideoPlayer.current = undefined
              setIsVideoStart(false)
              setTimeout(() => {
                videoRef.current.seekTo(0)
                setSeekValue(0)
                setDummySeekValue(0)
              }, 700)
              // handleVideoClose(true)
            }}
            onDuration={(seconds) => {
              setVideoDuration(seconds)
            }}
            onProgress={(progress) => {
              setSeekValue(progress.playedSeconds)
              setDummySeekValue(progress.playedSeconds)
            }}
            controls={false}
          />

          <span
            style={{
              position: 'absolute',
              top: 0,
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              height: '100%'
            }}
          >
            {!playing ? (
              <PlayIcon
                onClick={toggle}
                style={{
                  width: '100px',
                  height: '100px',
                  //marginRight: "1%",
                  color: '#0093d1',
                  cursor: 'pointer'
                }}
              />
            ) : (
              <PauseIcon
                onClick={toggle}
                style={{
                  width: '100px',
                  height: '100px',
                  //marginRight: "1%",
                  color: '#0093d1',
                  cursor: 'pointer'
                }}
              />
            )}
          </span>

          <div
            style={{
              width: '100%',
              //backgroundColor: "#BDBDBD",
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              position: 'absolute',
              bottom: '5%',
              alignItems: 'center',
              pointerEvents: isVideoStart
                ? 'auto'
                : internalDisplay
                ? 'auto'
                : 'none'
            }}
          >
            {!externalPopupVisible && !textPopupVisible && (
              <div
                style={{
                  width: '80%',
                  position: 'relative',
                  pointerEvents: VideoSkip && playing ? 'auto' : 'none'
                }}
              >
                <input
                  type='range'
                  id='myRange'
                  min={0}
                  max={videoDuration}
                  value={seekValue}
                  onInput={(event) => {
                    setManualSeekValue(event.target.value)
                  }}
                  style={{ width: '100%', zIndex: 5, cursor: 'pointer' }}
                />
                {video.MarkData &&
                  video.MarkData.map((marData, index) => {
                    let markerDuration = funcMarkerDuration(marData.Seconds)
                    let checkMarkPresent =
                      markerStatusList &&
                      markerStatusList.hasOwnProperty(marData.MarkerValue)
                    return (
                      <MarkIcon
                        key={index.toString()}
                        style={{
                          width: '25px',
                          height: '25px',
                          position: 'absolute',
                          top: '-10px',
                          left: (markerDuration * 100) / videoDuration + '%',
                          zIndex: 1,
                          cursor: 'pointer',
                          color:
                            completed === 0
                              ? checkMarkPresent
                                ? 'yellow'
                                : 'red'
                              : '#0bff31'
                        }}
                        onClick={() => {
                          setManualSeekValue(markerDuration)
                        }}
                      />
                    )
                  })}
              </div>
            )}
          </div>
        </div>
        {externalPopupVisible && renderExternalPopup()}
        {textPopupVisible && renderPopupText()}
        {resumeVideoStatus && renderResumeToast()}
        {isVideoStart &&
          !externalPopupVisible &&
          !textPopupVisible &&
          renderCloseIcon()}
      </div>
    </div>
  )
}

export default VideoCoreComponent
